import MobileDetect from 'mobile-detect';
// http://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html
var md = new MobileDetect(navigator.userAgent);
var os = md.os();
var mobile = md.mobile();
export var isMobile = !!mobile;
export var isAndroid = os === 'AndroidOS';
export var isIPad = md.tablet() === 'iPad';
export var isIPhone = mobile === 'iPhone';
export var isIOS = isIPad || isIPhone;
// TODO:
// Use something like
// https://github.com/rafrex/detect-touch
// to detect touch devices?
export var hasTouch = isMobile;
